export const INTENDED_USE_MAX_LENGTH = 50
export const TEMPLATE_OPTIONS = [
  { name: 'Windows Server 2025 (Desktop Experience)', os: 'Windows' },
  { name: 'Windows Server 2025 (Core)', os: 'Windows' },
  { name: 'Windows Server 2022 (Desktop Experience)', os: 'Windows' },
  { name: 'Windows Server 2022 (Core)', os: 'Windows' },
  { name: 'Windows Server 2019 (Desktop Experience)', os: 'Windows' },
  { name: 'Windows Server 2019 (Core)', os: 'Windows' },
  { name: 'Debian 13 (Trixie)', os: 'Linux' },
  { name: 'Debian 12 (Bookworm)', os: 'Linux' },
  { name: 'Ubuntu 26.04 LTS', os: 'Linux' },
  { name: 'Ubuntu 24.04 LTS', os: 'Linux' },
  { name: 'Ubuntu 22.04 LTS', os: 'Linux' },
  { name: 'RockyLinux 10 (RedHat Klon)', os: 'Linux' },
  { name: 'RockyLinux 9 (RedHat Klon)', os: 'Linux' },
  { name: 'RockyLinux 8 (RedHat Klon)', os: 'Linux' },
  { name: 'Other', os: 'Other' },
]
export const LIMITS = {
  cpu: { max: 16, minByOs: { Linux: 1, Windows: 2, Other: 1 } },
  ram: { max: 64, minByOs: { Linux: 1, Windows: 4, Other: 1 } },
  disk: { minByOs: { Linux: 8, Windows: 40, Other: 8 } },
}
export const emptyContact = () => ({ name: null, email: null })
export const SCC_REGEX = /^SCC/
// 4 Ziffern ODER 15 Ziffern + Prüfziffer 1/2 (Punkte werden vorher entfernt)
export const COST_CENTER_PATTERN = /^(?:\d{4}|\d{15}[12])$/
